import './App.css';
// import { BrowserRouter as Router, Route, Link, Routes } from 'react-router-dom';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import Home from './Components/Home';
import SkillDetails from './Components/SkillDetail';
import Header from './Components/Header';

function App() {
  return (
        <><Router>
        {/* <nav>
            <Link to="/">Home</Link>
            <Link to="/skillDetails">Skill Details</Link>
        </nav> */}
        <div className="App">
          <Header />

        <Routes>
            <Route path="/" element={<Home />} exact />
            <Route path="/sd" element={<SkillDetails />} />
        </Routes>
        <div>V1.03 19-06-2025</div>
      </div>

    </Router>
    </>
  );
}

export default App;
